export const heights = () => {
    let header_nav;
    header_nav = document.querySelector('#header');

    if (header_nav) {
        document.documentElement.style.setProperty('--h-nav', header_nav.getBoundingClientRect().height + 'px');
    }
}
